export default __webpack_public_path__ + "static/media/something-went-wrong.cb20d671.png";